// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Menu from 'components/menu/menu'
const siteURL = siteData.site_url
const logoTextSVG = siteData.images_url + 'logo/adventist_church_in_nzpuc_text_horizontal_white.svg?v=2'
const logoTextPNG = siteData.images_url + 'logo/adventist_church_in_nzpuc_text_horizontal_white.png?v=2'

// Redux:
import { openMenu, closeMenu } from 'actions/site'

class HeaderMobilePrimary extends React.Component {
	constructor( props ) {
		super( props )

		this.handleMenuButtonClick = this.handleMenuButtonClick.bind( this )
	}

	handleMenuButtonClick() {
		if ( this.props.menuIsOpen ) {
			this.props.handleCloseMenu()
		} else {
			this.props.handleOpenMenu()
		}
	}

	render() {
		const menuButtonClass = this.props.menuIsOpen ? 'is-active' : ''

		return [
			<div key="mobile-header-top" className="mobile-header-top">
				<div className="-logo">
					<a href={ siteURL }>
						<img src={ logoTextSVG } data-fallback={ logoTextPNG } alt="" />
					</a>
				</div>
			</div>,

			<div key="mobile-nav" className="mobile-nav">
				<div className={ '-menu-button ' + menuButtonClass } type="button" onClick={ this.handleMenuButtonClick }>
					<div className="-hamburger-box">
						<div className="-hamburger-inner"></div>
					</div>
				</div>

				<h3 className="-text" onClick={ this.handleMenuButtonClick }>Menu</h3>

				<Menu />
			</div>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleOpenMenu() {
			dispatch( openMenu() )
		},

		handleCloseMenu() {
			dispatch( closeMenu() )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( HeaderMobilePrimary )



// WEBPACK FOOTER //
// ./components/HeaderPrimary/HeaderMobilePrimary.jsx